import React, {Component} from 'react';
import {Container} from 'reactstrap';
import Jumbo  from '../../components/Jumbo/Jumbo';
import Iframe from 'react-iframe';
import cover from '../../assets/images/contact/IMG_1065.jpg'

class Timetable extends Component {
    state = {
        events: [],
        errors: null,
    };

    render(){
        return(
            <div className='timetable'>
                <Jumbo title='Vår åpningstid' content='Her finner du våre åpningstider på Ungdomssamfundet. Kalenderen viser også arrangementer vi avholder i løpet av året.' button="false" image={cover} />
                <Container>
                    <div className='kalender-apning'>
                        <Iframe
                            url="https://calendar.google.com/calendar/embed?src=extragiverglede.no_6hqdate3l74qpqm30uu7pet7d0%40group.calendar.google.com&ctz=Europe%2FOslo"
                            style={{border: 0}} width="1100" height="600" frameBorder="0" scrolling="no" position='relative'>iFrame</Iframe>
                    </div>
                </Container>
            </div>
        )
    }
}

export default Timetable;


// WEBPACK FOOTER //
// ./src/containers/Timetable/Timetable.js